module.exports = __webpack_public_path__ + "static/media/logohome.68e6ab80.png";